import React from 'react';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';
import { staticURL } from 'core/url';
import { inWhitelabel } from 'core/whitelabel';

import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { Editor } from 'libs/editor';

import { MainWrapper, Divider, Center } from 'legacyComponents/styled/lib';
import { media } from 'legacyComponents/styled/styleUtils';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';
import { Banner, Button } from 'components';

import { StoryAppManager } from 'apps/story/main/appManager';
import { StoryIndicator } from 'apps/story/views/storyIndicator';
import { StoryWrapper, Article } from 'apps/story/styles';
import { BottomStickyWrapper, CtaButton } from 'apps/home/landing/styles';

import { MicroSitePageManager } from 'apps/microSite/pages/appManager';
import { ViralResponseLanding } from 'apps/microSite/pages/customLanding/viralResponse';

@withNamespaces()
@inject('clientStore')
@observer
export class MicroSiteLanding extends React.Component {
  UNSAFE_componentWillMount() {
    if (this.props.whitelabelConfig.id !== 'viralresponse') {
      this.appManager = new StoryAppManager(this, this.props);
      this.sectionsManager = new MicroSitePageManager(null, this.props);
    }
  }

  signUp = () => {
    const { clientStore } = this.props;
    clientStore.routerStore.navigate('home.signIn', {
      next: 'home.contribute',
    });
  };

  toPlatform = () => {
    const { clientStore } = this.props;
    clientStore.routerStore.navigate('home.contribute');
  };

  render() {
    const { whitelabelConfig, clientStore } = this.props;
    if (whitelabelConfig.id === 'viralresponse') {
      return <ViralResponseLanding />;
    }
    const { loading, story } = this.appManager;
    if (loading) {
      return <StoryIndicator />;
    }
    if (story === null) {
      return (
        <MainWrapper marginTop='102px' marginBottom='10px'>
          <Banner variant='warning'>
            No Story found. Please ensure that a Story exists at the specified
            &quot;storySpace&quot; and &quot;storySlug&quot;. Thanks!
          </Banner>
        </MainWrapper>
      );
    }
    // FIXME - look into avoiding store creation during render
    const store = new EditorStore({
      initialValue: html.deserialize(story.body || '<p></p>'),
      formatting: 'advanced',
    });

    const { pageConfig } = this.sectionsManager;
    const sections = [];
    pageConfig.sections.forEach((section, index) => {
      const sectionKey = `${section.name
        .replace(/\s/g, '')
        .toLowerCase()}ConnManager`;
      sections.push(
        <CardSection
          key={sectionKey}
          title={section.name}
          subTitle={' '}
          ownerName={whitelabelConfig.shortTitle || whitelabelConfig.title}
          cardApp={this.sectionsManager[sectionKey].arrayApp}
          CardComponent={ProjectCard}
          noDataCardType='project'
          first={index === 0}
          owner={true}
          isWhitelabel={true}
          noSort={true}
        />,
      );
    });

    return (
      <Wrapper>
        <Article>
          <LogoWhiteLabel
            src={inWhitelabel() ? staticURL(whitelabelConfig.logo) : ''}
          />
          <Title>{whitelabelConfig.title}</Title>
          <SubTitle>{whitelabelConfig.subTitle}</SubTitle>
          <StoryWrapper margin='40px auto 0 auto'>
            <Editor store={store} />
          </StoryWrapper>
          <Divider width='100%' margin='20px auto 40px auto' />
        </Article>
        <BottomStickyWrapper>
          <Center>
            {clientStore.signedInProfile ? (
              <CtaButton
                onClick={this.toPlatform}
                text={whitelabelConfig.pages.home.cta.signedIn.text}
              />
            ) : (
              <CtaButton
                onClick={this.signUp}
                text={whitelabelConfig.pages.home.cta.signedOut.text}
              />
            )}
          </Center>
        </BottomStickyWrapper>
        {sections}
        <Center>
          <Link name='home.contribute'>
            <Button text='Discover more' outline />
          </Link>
        </Center>
      </Wrapper>
    );
  }
}

const Wrapper = styled(MainWrapper)`
  margin-top: 102px;
  margin-bottom: 40px;
  ${media.s`
    margin-top: 82px;
  `};
`;

const LogoWhiteLabel = styled.img`
  display: block;
  width: 100px;
  height: 100px;
  margin: 0px auto;
  ${media.s`
    width: 80px;
    height: 80px;
  `};
`;

const Title = styled.h1`
  text-align: center;
  margin: 20px 0;
  font-size: 1.4em;
  ${media.s`
    font-size: 1.2em;
  `};
`;

const SubTitle = styled.p`
  text-align: center;
  font-style: italic;
  font-size: 17px;
  color: #3d3d3d;
  line-height: 1.6;
  text-align: center;
  ${media.s`
    font-size: 15px;
  `};
`;

MicroSiteLanding.propTypes = {
  clientStore: PropTypes.object,
  whitelabelConfig: PropTypes.object,
  params: PropTypes.object,
  route: PropTypes.object,
};
